import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import Immutable from 'immutable';

import { getBreakpointFromManor } from 'ctm-components';

import { withSelectedProducts } from '../../products/compare_drawer/common/with_selected_products';
import { ComparingProductsIntro } from './comparing_products_intro';
import { ComparingProductsKeyInformation } from './comparing_products_key_information';
import { ComparingProductsFeaturesBenefits } from './comparing_products_features_benefits';
import { MAX_COMPARING_PRODUCTS_NUM } from '../../products/products/common/with_product_compare_action';
import {
    ComparingProductsStickies,
    StickyTriggerPointId,
    ParentNodeId
} from './comparing_products_stickies';

const useStyles = createUseStyles((theme) => ({
    tableCell: {
        width: ({ cellWidthPercentage }) => cellWidthPercentage
    }
}));

const _ComparisonProducts = ({ className, selectedProducts }) => {
    const breakpoint = getBreakpointFromManor();

    const comparingCount = selectedProducts ? selectedProducts.size : 0;
    const columnCount = ['xs', 'sm'].includes(breakpoint)
        ? comparingCount
        : comparingCount + 1;
    const cellWidthPercentage = `${100 / columnCount}%`;

    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, cellWidthPercentage });

    // stack mode is for xs and sm
    const stackDisplayMode = columnCount === comparingCount;
    const isShowRemoveButtons = comparingCount === MAX_COMPARING_PRODUCTS_NUM;

    return (
        <div
            id={ParentNodeId}
            className={classNames('test-policyComparison-products', className)}
        >
            <ComparingProductsIntro
                selectedProducts={selectedProducts}
                cellClassName={classes.tableCell}
                stackDisplayMode={stackDisplayMode}
                isShowRemoveButtons={isShowRemoveButtons}
            />
            <div id={StickyTriggerPointId.FIRST} />
            <ComparingProductsKeyInformation
                selectedProducts={selectedProducts}
                cellClassName={classes.tableCell}
                stackDisplayMode={stackDisplayMode}
                columnCount={columnCount}
            />
            <div id={StickyTriggerPointId.SECOND} />
            <ComparingProductsFeaturesBenefits
                selectedProducts={selectedProducts}
                cellClassName={classes.tableCell}
                stackDisplayMode={stackDisplayMode}
                columnCount={columnCount}
            />
            <ComparingProductsStickies
                selectedProducts={selectedProducts}
                cellClassName={classes.tableCell}
                stackDisplayMode={stackDisplayMode}
            />
        </div>
    );
};

_ComparisonProducts.propTypes = {
    className: PropTypes.string,
    selectedProducts: PropTypes.instanceOf(Immutable.List)
};

const ComparisonProducts = withSelectedProducts(_ComparisonProducts);

export { ComparisonProducts };
